import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const AddItemIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g transform="translate(7 5)" fill={color}>
          <rect
            fillRule="nonzero"
            opacity=".12"
            x=".75"
            y="3.75"
            width="14"
            height="18"
            rx="3"
          />
          <path d="M14.75 0a.75.75 0 0 1 .75.75V3h2.25a.75.75 0 0 1 0 1.5H15.5v2.25a.75.75 0 0 1-1.5 0V4.5h-2.25a.75.75 0 0 1 0-1.5H14V.75a.75.75 0 0 1 .75-.75ZM5.518 3H8.25a.75.75 0 0 1 0 1.5h-2.7c-.852 0-1.447 0-1.91.038-.453.037-.714.107-.911.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v8.4c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h4.4c.853 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909v-6.7a.75.75 0 0 1 1.5 0v6.732c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.638 1.64c-.445.226-.925.32-1.471.365-.531.043-1.187.043-2 .043H5.518c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47C0 18.45 0 17.794 0 16.982V8.518c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365C4.05 3 4.706 3 5.519 3ZM4.75 7a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6ZM4 11.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM4.75 15a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z" />
        </g>
      </g>
    </svg>
  );
};
